import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { CamelOrderService } from '@/services/CamelOrder/CamelOrderService';

export type PresignedResponse = {
  url: string;
};

export type PresignedRequest = {
  filePath: string;
  contentType: string;
};

export const useCamelOrderPresigned = async (
  params: PresignedRequest
): Promise<PresignedResponse> => {
  const siteService = new CamelOrderService(getClient());
  try {
    const res = await siteService.presigned(params);
    return res;
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
